// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"c81a77c5","154":"2ffbd950","274":"6e0ab059","280":"9b46d132","348":"3f1e960c","453":"8b334368","482":"3f25bf15","537":"8487f54e","611":"11f11906","658":"772f304c","815":"bb151af7","967":"cf16d951"}[chunkId] + ".chunk.js";
};